import React from 'react'
import "../Styles/Blog.css"
const Blogbody = () => {
  return (
    <>
      <main className='container-fluid bg-white border-bottom'>
        <div className='container'>
          <p className='nnny'>no news yet...</p>
        </div>
      </main>
    </>
  )
}

export default Blogbody